export const VOICE_RECOGNITION_IDLE_MS = 8000
export const VOICE_RECOGNITION_EOS_MS = 2000
export const VOICE_STATUS_HIDE_MS = 3200
export const VOICE_PENDING_ACTION_KEY = 'wy_big_data_voice_pending_action'

export const VOICE_COMMAND_LIST = [
  {
    id: 'switch-market',
    label: '切换到文旅市场',
    action: 'switchType',
    payload: {
      typeIndex: 0
    },
    phrases: ['切换到文旅市场', '打开文旅市场', '进入文旅市场', '切到文旅市场', '文旅市场']
  },
  {
    id: 'switch-flow-analysis',
    label: '切换到客流分析',
    action: 'switchType',
    payload: {
      typeIndex: 1
    },
    phrases: ['切换到客流分析', '打开客流分析', '进入客流分析', '切到客流分析', '客流分析']
  },
  {
    id: 'switch-big-data-cockpit',
    label: '切换到大数据驾驶舱',
    action: 'switchType',
    payload: {
      typeIndex: 2
    },
    phrases: ['切换到大数据驾驶舱', '打开大数据驾驶舱', '进入大数据驾驶舱', '切到大数据驾驶舱', '打开驾驶舱', '进入驾驶舱', '驾驶舱', '大数据驾驶舱']
  },
  {
    id: 'switch-sentiment-analysis',
    label: '切换到舆情分析',
    action: 'switchType',
    payload: {
      typeIndex: 3
    },
    phrases: ['切换到舆情分析', '打开舆情分析', '进入舆情分析', '切到舆情分析', '舆情分析']
  },
  {
    id: 'switch-warning',
    label: '切换到客流预警',
    action: 'switchType',
    payload: {
      typeIndex: 4
    },
    phrases: ['切换到客流预警', '打开客流预警', '进入客流预警', '切到客流预警', '客流预警', '预警页']
  },
  {
    id: 'go-prev-day',
    label: '前一天',
    action: 'changeDate',
    payload: {
      day: -1
    },
    phrases: ['前一天', '上一天']
  },
  {
    id: 'go-next-day',
    label: '后一天',
    action: 'changeDate',
    payload: {
      day: 1
    },
    phrases: ['后一天', '下一天']
  },
  {
    id: 'open-bus-route-viewer',
    label: '打开公交路线图',
    action: 'openBusRouteViewer',
    phrases: ['打开公交路线图', '打开公交路线', '查看公交路线图', '查看公交路线', '打开旅游公交路线图', '旅游公交路线图', '公交路线图']
  }
]

export function normalizeVoiceText(text) {
  return String(text || '')
    .replace(/[，。！？、,.!?\s]/g, '')
    .replace(/请/g, '')
    .replace(/帮我/g, '')
    .replace(/把/g, '')
    .replace(/一下/g, '')
    .replace(/页面/g, '')
    .replace(/界面/g, '')
    .trim()
}

export function findVoiceCommandMatch(transcripts, options = {}) {
  const candidateList = Array.isArray(transcripts) ? transcripts : [transcripts]
  const normalizedCandidates = candidateList.map(normalizeVoiceText).filter(Boolean)
  const preventPrefixOnlyMatch = !!options.preventPrefixOnlyMatch

  for (let candidateIndex = 0; candidateIndex < normalizedCandidates.length; candidateIndex++) {
    const candidate = normalizedCandidates[candidateIndex]
    const cameraCommand = buildCameraVoiceCommand(candidate, {
      preventDefaultMatch: preventPrefixOnlyMatch
    })
    if (cameraCommand) {
      return {
        command: cameraCommand,
        transcript: candidateList[candidateIndex] || ''
      }
    }
    for (let commandIndex = 0; commandIndex < VOICE_COMMAND_LIST.length; commandIndex++) {
      const command = VOICE_COMMAND_LIST[commandIndex]
      for (let phraseIndex = 0; phraseIndex < command.phrases.length; phraseIndex++) {
        const normalizedPhrase = normalizeVoiceText(command.phrases[phraseIndex])
        if (candidate.indexOf(normalizedPhrase) === -1) {
          continue
        }
        if (preventPrefixOnlyMatch && candidate === normalizedPhrase && hasLongerPhraseWithPrefix(normalizedPhrase)) {
          continue
        }
          return {
            command: command,
            transcript: candidateList[candidateIndex] || ''
          }
      }
    }
  }

  return null
}

// 摄像头配置映射
const CAMERA_CONFIG_MAP = [
  {
    name: '篁岭晒秋平台',
    aliases: ['篁岭晒秋平台', '晒秋平台'],
    url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000005.flv'
  },
  {
    name: '篁岭游客中心',
    aliases: ['篁岭游客中心', '游客中心'],
    url: 'http://121.40.47.136:50080/video/0402b05801a098b1/0000000003.flv'
  }
]

function buildCameraVoiceCommand(candidate, options = {}) {
  const cameraPattern = /(?:切换到|看一眼|调取|调出|打开|查看|切到|进入|调看|看下|调)(.*?)(?:摄像头|监控画面|视频监控|监控视频|监控)/
  const matched = candidate.match(cameraPattern)
  if (!matched) {
    return null
  }
  const cameraName = normalizeCameraName(matched[1])
    .replace(/^(?:取|出|到)/, '')
    .trim()

  // 查找匹配的摄像头配置
  const matchedCamera = findCameraConfig(cameraName)

  // 如果找到了匹配的摄像头，返回播放命令
  if (matchedCamera) {
    return {
      id: 'play-camera-monitor',
      label: '调取' + matchedCamera.name + '摄像头',
      action: 'playCamera',
      payload: {
        cameraName: matchedCamera.name,
        cameraUrl: matchedCamera.url
      }
    }
  }

  // 中间识别结果或未知摄像头名称不回退默认流，避免先打开错误视频源。
  if (options.preventDefaultMatch || cameraName) {
    return null
  }

  // 只有没有说具体摄像头名称时，默认播放第一个
  return {
    id: 'play-camera-monitor',
    label: cameraName ? ('调取' + cameraName + '摄像头') : '调取摄像头',
    action: 'playCamera',
    payload: {
      cameraName: CAMERA_CONFIG_MAP[0].name,
      cameraUrl: CAMERA_CONFIG_MAP[0].url
    }
  }
}

function normalizeCameraName(name) {
  return String(name || '')
    .replace(/景区/g, '')
    .trim()
}

function findCameraConfig(cameraName) {
  if (!cameraName) {
    return null
  }
  return CAMERA_CONFIG_MAP.find(config => {
    const names = [config.name].concat(config.aliases || [])
    return names.some(name => {
      const normalizedName = normalizeCameraName(name)
      return normalizedName && (
        normalizedName.includes(cameraName) ||
        cameraName.includes(normalizedName)
      )
    })
  })
}

function hasLongerPhraseWithPrefix(normalizedPhrase) {
  for (let commandIndex = 0; commandIndex < VOICE_COMMAND_LIST.length; commandIndex++) {
    const command = VOICE_COMMAND_LIST[commandIndex]
    for (let phraseIndex = 0; phraseIndex < command.phrases.length; phraseIndex++) {
      const phrase = normalizeVoiceText(command.phrases[phraseIndex])
      if (phrase !== normalizedPhrase && phrase.indexOf(normalizedPhrase) === 0) {
        return true
      }
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/voiceCommandConfig.js